import {
    allFetch
} from "../Domain";

/**
 * @description 車(匯入跟MOS用的跟訂單車源不一樣)
 */
export const Car = (() => {
    /**
     * @description 車籍查詢
     */
    const CarSearch = async function (obj = {
        vin_no: '',
        license_plate: '',
        customer_id: '',
        car_id: '',
        page: 0,
        num_per_page: ''
    }) {
        return await allFetch('Car/CarSearch', obj);
    }
    /**
     * @description 車籍新建
     */
    const CarCreate = async function (obj = {
        vin_no: '',
        license_plate: '',
        customer_id: '',
        driver_name: '',
        driver_phone: '',
        ctf_id: '',
        year: ''
    }) {
        return await allFetch('Car/CarCreate', obj);
    }
    /**
     * @description 車籍查詢
     */
    const CarDetail = async function (obj = {
        car_id: ''
    }) {
        return await allFetch('Car/CarDetail', obj);
    }
    /**
     * @description 車新增(MOS用)
     */
    const CarCreateFromExcel = async function (obj = {
        vin_no: '',
        license_plate: '',
        driver_name: '',
        driver_phone: ''
    }) {
        return await allFetch('Car/CarCreateFromExcel', obj);
    }
    /**
     * @description 車修改(MOS用)
     */
    const CarUpdateFromExcel = async function (obj = {
        car_id: '',
        vin_no: '',
        license_plate: '',
        driver_name: '',
        driver_phone: ''
    }) {
        return await allFetch('Car/CarUpdateFromExcel', obj);
    }
    /**
     * @description 車籍修改車主(MOS用)
     */
    const CarUpdateCustomer = async function (obj = {
        car_id: '',
        customer_id: ''
    }) {
        return await allFetch('Car/CarUpdateCustomer', obj);
    }
    /**
     * @description 車修改
     */
    const CarUpdate = async function (obj = {
        car_id: '',
        license_plate: '',
        customer_id: '',
        driver_name: '',
        driver_phone: '',
        ctf_id: '',
        year: ''
    }) {
        return await allFetch('Car/CarUpdate', obj);
    }

    /** 攝影機清單查詢
    * @param visible 是否可見
    * @param ip IP
    * @param name 攝影機名稱
    * @param position_id 據點代碼
    * @param type 攝影機類別
    * @param isopengate 是否可以開門
    */
    const CameraListSearch = async function (obj = {
        visible: '',
        ip: '',
        name: '',
        position_id: '',
        type: '',
        isopengate: '',
    }) {
        return await allFetch('Car/CameraListSearch', obj);
    }

    /** 攝影機觸發開門
    * @param camera_id 攝影機代碼
    */
    const OpenGate = async function (obj = {
        camera_id: '',
    }) {
        return await allFetch('Car/OpenGate', obj);
    }

    return {
        CarSearch,
        CarCreate,
        CarDetail,
        CarCreateFromExcel,
        CarUpdateFromExcel,
        CarUpdateCustomer,
        CarUpdate,
        CameraListSearch,
        OpenGate,
    }
})();